import { useMutation } from "@tanstack/react-query";
import Swal from "sweetalert2";
import { queryClient } from "../../..";
import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";
import { MovimentoForm } from "../types";

export default function useSaveMovimento(onSuccess: () => void) {
  return useMutation((value: MovimentoForm) =>
    api
      .post(URLS.MOVIMENTOS_API, value)
      .then((response) => {
        console.log(response);
        queryClient.invalidateQueries();
        Swal.fire({
          title: "Movimento Cadastrado",
          text: "O movimento foi cadastrado com sucesso!",
          icon: "success",
          position: "center",
          confirmButtonText: "OK",
          confirmButtonColor: "#349946",
        }).then((response) => {
          if(response.isConfirmed) {
            onSuccess();
          }
        });
      })
      .catch((err) => {
        console.log(err);
        err.response.status === 500 ?
          Swal.fire({
            title: `Erro de status ${err.response.status}`,
            text: `Ocorreu um erro interno ao cadastrar o movimento. Por favor, entre em contato com um administrador do sistema.`,
            icon: "error",
            position: "center",
            confirmButtonText: "OK",
            confirmButtonColor: "#F27474",
          })
        :
          Swal.fire({
            title: "Erro ao cadastrar movimento",
            text: err.response.data.message,
            icon: "error",
            position: "center",
            confirmButtonText: "OK",
            confirmButtonColor: "#F27474",
          });
        }
      )
  )
}
